import { Auth } from 'aws-amplify';

const forgotPassword = async (action) => {
  try {
    var data = await Auth.forgotPassword(action.email);
    //console.log(`data back from forgotPassword.js: ${JSON.stringify(data)}`);
    return data;
  } catch (e) {
    console.log('awsUserResetPassword:forgotPassword - Error getting code for reset password: ', e);
    return e;
  }
};

const forgotPasswordSubmit = async (action) => {
  try {
    var data = await Auth.forgotPasswordSubmit(action.email, action.code, action.newPassword);
    return data;
  } catch (e) {
    console.log('awsUserResetPassword:forgotPasswordSubmit - Error reset password: ', e);
    return e;
  }
};

const changePassword = async (action) => {
  try {
    let user = await Auth.currentAuthenticatedUser();
    var data = await Auth.changePassword(user, action.password, action.newPassword);
    return data;
  } catch (e) {
    console.log('awsUserResetPassword:changePassword - Error change password: ', e);
    return e;
  }
};
export default { forgotPassword, forgotPasswordSubmit, changePassword };
